/**
 * 巫女キャラ定義 — §2.7 Progress でアンロックを表示する。
 * 仕様書 §03 のキャラ案に整合。Phase 1 はテンプレ + シルエット表現。
 *
 * Track C のキャラ立ち絵が来たら image を差し替えるだけで使える形。
 */

export type MikoId =
  | "haru"
  | "natsu"
  | "tsuki"
  | "yuki"
  | "kagura"
  | "amaterasu";

export type MikoCharacter = {
  id: MikoId;
  /** どのティアでアンロックされるか (累積引数) */
  unlockTier: number;
  /** 表示用の名前 (毛筆で表示) */
  name: { ja: string; en: string };
  /** 一言キャッチコピー */
  tagline: { ja: string; en: string };
  /** カラーアクセント (Tailwind 経由ではなく直接 token) */
  accent: string;
  /** placeholder のシルエット記号 */
  glyph: string;
};

export const MIKO_CHARACTERS: MikoCharacter[] = [
  {
    id: "haru",
    unlockTier: 0, // 最初から
    name: { ja: "春", en: "Haru" },
    tagline: {
      ja: "桜散る境内の、初々しい巫女。",
      en: "The maiden of cherry petals at the entry shrine.",
    },
    accent: "#f9c1cf",
    glyph: "春",
  },
  {
    id: "natsu",
    unlockTier: 5,
    name: { ja: "夏", en: "Natsu" },
    tagline: {
      ja: "風鈴の音と共に現れる、夏祭りの巫女。",
      en: "The summer-festival maiden, arriving with wind-chimes.",
    },
    accent: "#7ec5e6",
    glyph: "夏",
  },
  {
    id: "tsuki",
    unlockTier: 10,
    name: { ja: "月", en: "Tsuki" },
    tagline: {
      ja: "月明かりの下で札を読む、夜の巫女。",
      en: "The night maiden, reading slips beneath moonlight.",
    },
    accent: "#dfd8a8",
    glyph: "月",
  },
  {
    id: "yuki",
    unlockTier: 30,
    name: { ja: "雪", en: "Yuki" },
    tagline: {
      ja: "雪の朝、深い静寂を運ぶ巫女。",
      en: "The maiden of snow, bearing deep silence at dawn.",
    },
    accent: "#e8eef3",
    glyph: "雪",
  },
  {
    id: "kagura",
    unlockTier: 50,
    name: { ja: "神楽", en: "Kagura" },
    tagline: {
      ja: "神楽鈴を奏でる、舞う巫女。",
      en: "The dancing maiden, ringing kagura bells.",
    },
    accent: "#c9a961",
    glyph: "舞",
  },
  {
    id: "amaterasu",
    unlockTier: 100,
    name: { ja: "天照", en: "Amaterasu" },
    tagline: {
      ja: "千の縁を照らす、太陽の巫女。",
      en: "The sun maiden, who lights a thousand bonds.",
    },
    accent: "#ffd470",
    glyph: "陽",
  },
];

/**
 * 全ペアの最大累積回数を引数に、アンロック済みかを判定。
 */
export function isMikoUnlocked(
  miko: MikoCharacter,
  maxTotalDraws: number,
): boolean {
  return maxTotalDraws >= miko.unlockTier;
}
